import APIService from 'services/APIService'

const api = APIService()

export const fetchTutorials = () => {
  return api.get('/tutorials')
}
